// extracted by mini-css-extract-plugin
export default {"root":"Range_root__qroZd","label":"Range_label__Ch0R+","numberInput":"Range_numberInput__35Cdt"};